import { render, staticRenderFns } from "./TagEditMenu.vue?vue&type=template&id=5607b11c&scoped=true"
import script from "./TagEditMenu.vue?vue&type=script&lang=js"
export * from "./TagEditMenu.vue?vue&type=script&lang=js"
import style0 from "./TagEditMenu.vue?vue&type=style&index=0&id=5607b11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607b11c",
  null
  
)

export default component.exports